// HOC/AuthCheck.tsx
import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/auth/useAuth";
import Loader from "../components/common/ui/loader/Loader";

const AuthCheck: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data, isLoading, isError } = useAuth();

  useEffect(() => {
    if (!isLoading) {
      if (isError) {
        navigate("/auth/login");
      } else if (data && location.pathname === "/auth/login") {
        navigate("/feedbacks");
      }
    }
  }, [isLoading, isError, data, navigate, location]);

  if (isLoading) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthCheck;
